<script>
export default {
  props: {
    imgSrc: {
      type: String,
      required: true,
    },
  },
  methods: {
    removeImage() {
      this.$emit('removeImage')
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__imgWrapper">
      <img
        :src="imgSrc"
        :class="$style.container__img"
      >
    </div>
    <span
      :class="$style.container__notification"
      @click="removeImage()"
    >
      <BaseIcon
        name="close"
      />
    </span>

  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  position: relative;
  box-sizing: content-box;
  width: 5rem;
  height: 5rem;
  background-color: $pale-gray;
  border: 0.5rem solid $pale-gray;
  border-radius: 0.5rem;

  &__imgWrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  &__img {
    max-width: 100%;
    max-height: 100%;
  }

  &__notification {
    position: absolute;
    top: -1.1rem;
    right: -1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    color: #fff;
    background-color: $charcoal-gray;
    border-radius: 50%;
  }

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 2.5s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
